import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { collection, doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { Alert, Button, Snackbar } from '@mui/material';
import './admin.css';

const AddGuestForm = ({ mode }) => {
  const { documentId } = useParams();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [guestData, setGuestData] = useState({
    name: '',
  });

  useEffect(() => {
    if (mode === 'edit') {
      const loadGuestData = async () => {
        // const app = initializeApp(firebaseConfig);
        // const db = getFirestore(app);

        const docRef = doc(db, 'guest', documentId);
        const docSnapshot = await getDoc(docRef);

        if (docSnapshot.exists()) {
          const savedGuest = docSnapshot.data();
          setGuestData({ name: savedGuest.name || '' });
        } else {
          //console.log('Guest not found!');
        }
      };
      loadGuestData();
    }
  }, [mode, documentId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setError("");
    setGuestData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const participantName = guestData.name.trim();

    if (!participantName) {
      setError("Participant name is required.");
      return;
    }

    try {
      if (mode === 'edit') {
        const docRef = doc(db, 'guest', documentId);
        await updateDoc(docRef, { name: participantName });
        //console.log('Guest data updated successfully!');
        setOpenSnackbar(true);
        navigate("/trivia-night-admin-panel")
      } else {
        const newDocRef = doc(collection(db, 'guest'));
        await setDoc(newDocRef, { name: participantName, answers: [] });
        //console.log('New guest data added successfully!');
        navigate("/trivia-night-admin-panel")
      }
    } catch (error) {
      console.error('Error saving guest data: ', error);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <div className="admin-shell admin-guest-page">
      <form className="admin-guest-card" onSubmit={handleSubmit}>
        <div className="admin-guest-badge">Participant</div>
        <p className="admin-guest-kicker">50+ Desi Couples Trivia Night</p>
        <h1 className="admin-guest-title">{mode === 'edit' ? 'Edit Participant' : 'Add Participant'}</h1>
        <p className="admin-guest-subtitle">Add each player individually. Couple totals can be added manually at the end.</p>

        <div className="admin-field admin-guest-name-field">
          <label htmlFor="name">Player Name</label>
          <input
            autoFocus
            className="admin-input admin-guest-input"
            id="name"
            maxLength="48"
            name="name"
            placeholder="Example: Raj"
            type="text"
            value={guestData.name}
            onChange={handleInputChange}
            required
          />
        </div>
        {error && <Alert severity="error">{error}</Alert>}
        <div className="admin-actions admin-guest-actions">
          <Button type="submit" variant="contained">{mode === 'edit' ? 'Save Participant' : 'Add Participant'}</Button>
          <Button type="button" variant="outlined" onClick={() => navigate("/trivia-night-admin-panel")}>Cancel</Button>
        </div>
        <Snackbar
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
        >
          <Alert severity="success" variant="filled">Participant saved successfully!</Alert>
        </Snackbar>
      </form>
    </div>
  );
};

export default AddGuestForm;
